import Layout from "../Layout";
import Card from "../Layout/Card";
import Form from "./Form";

function RequiredSetPassword() {
	return (
		<Layout
			image="/assets/images/reset-password.jpg"
			text="It is during our darkest moments that we must focus to see the light."
			autor="Aristotle"
		>
			<Card
				cardTitle="set-new-password"
				cardText="set-new-password-description"
				cardFooter="need-help"
				link="#"
				linkText="help-center"
				cardBody={<Form />}
				className="text-center"
			/>
		</Layout>
	);
}

export default RequiredSetPassword;
